import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    paddingBottom: '2rem',
    width: '100%',
  },
  link: {
    cursor: 'pointer',
  }
});

const BreadcrumbHeader = ({title, item=null, back}) => {
  const classes = useStyles();
  if (item === null) {
    return (
      <div className={classes.root}>
        <Breadcrumbs>
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
        </Breadcrumbs>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Breadcrumbs>
          <Link variant="h6" color="inherit" onClick={back} className={classes.link}>
            {title}
          </Link>
          <Typography variant="h6" color="primary">
            {item}
          </Typography>
        </Breadcrumbs>
      </div>
    );
  }
};

BreadcrumbHeader.propTypes = {
  title: PropTypes.string.isRequired,
  item: PropTypes.string,
  back: PropTypes.func.isRequired,
};

export default BreadcrumbHeader;
